import { useMemo } from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { useAccount } from '../context/AccountContext'
import { useAuthentication } from '../context/AuthenticationContext'
import { solutionSupportsOwnerRestriction, normalizeOwnerRestriction } from '../utils/rolePermissions'

export const useOwnerRestriction = () => {
  const { solution, role } = useAuthentication().scope
  const { account } = useAccount()
  const { ownerRestricted } = useFlags()

  const accountSupportsOwnerRestriction = ownerRestricted && solutionSupportsOwnerRestriction(solution)

  const accountIsOwnerRestricted =
    accountSupportsOwnerRestriction && normalizeOwnerRestriction(role, solution, account?.isOwnerRestricted ?? false)

  return useMemo(
    () => ({
      accountSupportsOwnerRestriction,
      accountIsOwnerRestricted,
    }),
    [accountSupportsOwnerRestriction, accountIsOwnerRestricted],
  )
}
